export default [
  {
    text: 'Frente RG',
    value: 'RgFront',
  },
  {
    text: 'Verso RG',
    value: 'RgBack',
  },
  {
    text: 'Frente CNH',
    value: 'CnhFront',
  },
  {
    text: 'Verso CNH',
    value: 'CnhBack',
  },
  {
    text: 'Foto de perfil',
    value: 'Selfie',
  },
  {
    text: 'Fachada da loja',
    value: 'StoreFacade',
  },
  {
    text: 'Foto de confirmação do usuário',
    value: 'SelfieToConfirmUser',
  },
];
